import React from "react";
import { RouteComponentProps } from "react-router-dom";
import BruciatoreForm from "./bruciatoreForm";
import Actions from "../bruciatoriActions";
import Store from "../bruciatoriStore";
import { BruciatoreDto, BruciatoreDataDto } from "../../generated";
import { links } from "../../routes";
import { Loading } from "../../common/components/loading";


interface Props extends RouteComponentProps<{ id?: string }> {
}
const BruciatoreEdit = (props: Props) => {

    const { history, match: { params: { id } } } = props;

    const bruciatore = id ? Store.use(+id) : new BruciatoreDto();
    if (!bruciatore)
        return <Loading />

    const save = async (data: BruciatoreDataDto) => {
        if (id) {
            Actions.update(+id, data);
        }
        else {
            const { idBruciatore } = await Actions.add(data);
            history.replace(links.bruciatoriEdit(idBruciatore))
        }
    }

    const dto = new BruciatoreDataDto();
    if (bruciatore)
        dto.init(bruciatore)

    return (
        <BruciatoreForm
            bruciatore={dto}
            onSubmit={save}
            onCancel={() => history.push(links.bruciatori)}
        />
    );
}


export default BruciatoreEdit;